import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton } from 'src/components/ui'
import { useCreateBottle } from 'src/zustand/stores/createBottle.store'

import styles from '../../../InputNameOfBottle/InputNameOfBottle.module.scss'

interface Props {
  className?: string
}

const Charitable: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const inputRef = React.useRef<HTMLInputElement>(null)
  const addTargetOfBottle = useCreateBottle((state) => state.addTargetOfBottle)
  const targetOfBottle = useCreateBottle((state) => state.targetOfBottle)

  const [inputValue, setInputValue] = React.useState(
    targetOfBottle.split(' ')[0] === '' ? t('create_bottle.on') + targetOfBottle : targetOfBottle,
  )
  const navigate = useNavigate()

  const handleContinued = () => {
    addTargetOfBottle(inputValue)
    navigate(`/create-bottle/step-4?type=charitable`)
  }

  const handleChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setInputValue(value)

    e.target.style.width = `${Math.max(value.length)}ch`
  }

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_input}>
        <label htmlFor='input'>{t('create_bottle.input_target_bank')}</label>
        <input
          ref={inputRef}
          type='text'
          value={inputValue}
          onChange={handleChangeInputValue}
          style={{ width: `${Math.max(inputValue.length + 0.5, 1)}ch` }}
        />
      </div>
      <div className={styles.tabs}>
        <CustomButton
          onClick={handleContinued}
          variant={inputValue.length > 0 ? 'contained' : 'not-active'}
          color='white'
          className={styles.button}
        >
          {t('create_bottle.continue')}
        </CustomButton>
      </div>
    </div>
  )
}

export default Charitable
